import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  FaPencilAlt as PencilIcon,
  FaTrash as TrashIcon,
  FaClone as CloneIcon,
} from 'react-icons/fa';

import { ScenarioPropType } from '../shared/propTypes';

import { showRemoveScenarioModal } from './store/actions';
import {
  canCreatePublicScenarioSelector,
  canRemoveScenarioSelector,
} from './store/selectors';
import { GridMode } from '../../shared/gridEdit/useEditableGridLogic';
import ValidationMessagesCellRenderer from '../../shared/gridEdit/validationMessagesCellRenderer.component';


const ScenariosAdminColumnRenderer = props => {
  const {
    data: scenario,
    rowIndex,
    showRemoveScenarioModal,
    disableRemove,
    disableEdit,
    editRow,
    cloneScenario,
    user,
    canCreatePublicScenario,
    canRemoveAnyScenario,
    context: {
      mode,
    },
  } = props;


  const showDeleteModal = useCallback(() => {
    showRemoveScenarioModal({ entity: scenario, rowIndex });
  }, [showRemoveScenarioModal, rowIndex, scenario]);

  const onEditClick = useCallback(() => {
    editRow(scenario);
  }, [scenario, editRow]);

  const onCloneClick = useCallback(() => {
    cloneScenario(scenario);
  }, [cloneScenario, scenario]);

  const currentUserIsOwner = Number(user.sso) === Number(scenario.createdSso);

  const isEditing = mode === GridMode.Add || mode === GridMode.Edit;

  if (isEditing) {
    return <ValidationMessagesCellRenderer {...props} />;
  }

  return currentUserIsOwner || canCreatePublicScenario
    ? (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Scenario"
          onClick={onEditClick}
          disabled={disableEdit}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>
        {
          (canRemoveAnyScenario || scenario.createdSso === user.sso) && (
            <button
              className="cell-icon-button"
              title="Remove Scenario"
              onClick={showDeleteModal}
              disabled={disableRemove}
            >
              <TrashIcon size={16} className="cell-icon" />
            </button>
          )
        }
        <button
          className="cell-icon-button"
          title="Clone scenario"
          onClick={onCloneClick}
        >
          <CloneIcon size={16} className="cell-icon"/>
        </button>
      </div>
    )
    : null;
};

ScenariosAdminColumnRenderer.propTypes = {
  data: ScenarioPropType,
  showRemoveScenarioModal: PropTypes.func.isRequired,
  disableRemove: PropTypes.bool,
  disableEdit: PropTypes.bool,
  editRow: PropTypes.func.isRequired,
  cloneScenario: PropTypes.func.isRequired,
  rowIndex: PropTypes.number.isRequired,
  canCreatePublicScenario: PropTypes.bool,
  canRemoveAnyScenario: PropTypes.bool,
  user: PropTypes.shape({
    sso: PropTypes.string.isRequired,
  }).isRequired,
  context: PropTypes.shape({
    mode: PropTypes.string.isRequired,
  }),
};

const mapStateToProps = state => ({
  canCreatePublicScenario: canCreatePublicScenarioSelector(state),
  canRemoveAnyScenario: canRemoveScenarioSelector(state),
  user: state.user.user,
});

export default connect(mapStateToProps, {
  showRemoveScenarioModal,
})(ScenariosAdminColumnRenderer);
